'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.storage = exports.RGCaptcha = undefined;
exports.appendTo = appendTo;
exports.bindForm = bindForm;
exports.getValidate = getValidate;
exports.reset = reset;
exports.verify = verify;

var _isFunction = require('lodash/isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

var _storage = require('./storage');

var _storage2 = _interopRequireDefault(_storage);

var _RGCaptcha = require('./RGCaptcha');

var _RGCaptcha2 = _interopRequireDefault(_RGCaptcha);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.RGCaptcha = _RGCaptcha2.default;
exports.storage = _storage2.default;
function appendTo(name, position) {
  var _storage$get = _storage2.default.get(name),
      ins = _storage$get.ins;

  if (ins && (0, _isFunction2.default)(ins.appendTo)) return ins.appendTo(position);
  return null;
}

function bindForm(name, position) {
  var _storage$get2 = _storage2.default.get(name),
      ins = _storage$get2.ins;

  if (ins && (0, _isFunction2.default)(ins.bindForm)) return ins.bindForm(position);
  return null;
}

function getValidate(name) {
  var _storage$get3 = _storage2.default.get(name),
      ins = _storage$get3.ins;

  if (ins && (0, _isFunction2.default)(ins.getValidate)) return ins.getValidate();
  return null;
}

function reset(name) {
  var _storage$get4 = _storage2.default.get(name),
      ins = _storage$get4.ins;

  if (ins && (0, _isFunction2.default)(ins.reset)) return ins.reset();
  return null;
}

function verify(name) {
  var _storage$get5 = _storage2.default.get(name),
      ins = _storage$get5.ins;

  if (ins && (0, _isFunction2.default)(ins.verify)) return ins.verify();
  return null;
}

exports.default = {
  storage: _storage2.default,
  RGCaptcha: _RGCaptcha2.default,
  appendTo: appendTo,
  bindForm: bindForm,
  getValidate: getValidate,
  reset: reset,
  verify: verify
};